(function(){
    document.addEventListener('DOMContentLoaded', function(){
        const btnWhats = document.getElementById('whatsapp-btn');
        const whatsModal = document.getElementById('whatsapp-modal');
        const btnWhatsClose = document.getElementById('whatsapp-modal-close-button');
        btnWhats.addEventListener('click', function(){
            whatsModal.style.display = 'block';
            whatsModal.ariaHidden = false;
        });
        btnWhatsClose.addEventListener('click', function(){
            whatsModal.style.display = 'none';
            whatsModal.ariaHidden = true;
        });
    });
})()